import { getImagePath } from '@/utils/images';
import { Container, SectionHead } from './WebinarShared';
import { LinkedinIcon } from './WebinarIcons';

const WebinarSpeakers = ({ eyebrow, heading, intro, speakers }) => {
  return (
    <section className="bg-white py-16 md:py-[88px]">
      <Container>
        <SectionHead eyebrow={eyebrow} heading={heading} intro={intro} />
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {speakers?.map((speaker) => (
            <div
              key={speaker.id}
              className="flex items-start gap-[18px] rounded-2xl border border-[#e5e5e5] p-7 transition-[border-color,box-shadow] hover:border-[#d8d8d8] hover:shadow-[0_20px_40px_-24px_rgba(29,24,22,0.18)]"
            >
              {speaker.avatar?.url && (
                <img
                  src={getImagePath(speaker.avatar)}
                  alt={speaker.name || ''}
                  className="h-14 w-14 shrink-0 rounded-full bg-[#f5f5f5] object-cover"
                />
              )}
              <div>
                {speaker.org && (
                  <div className="mb-1 text-sm font-semibold tracking-[0.06em] text-brand-500 uppercase">
                    {speaker.org}
                  </div>
                )}
                <div className="mb-0.5 flex items-center gap-2">
                  {speaker.name && <span className="text-[17px] font-semibold text-grey-950">{speaker.name}</span>}
                  {speaker.linkedinUrl && (
                    <a
                      href={speaker.linkedinUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`LinkedIn ${speaker.name || ''}`}
                      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#f5f5f5] text-grey-500 transition-colors hover:bg-[#EBEFFF] hover:text-[#3963ff]"
                    >
                      <LinkedinIcon width={16} height={16} />
                    </a>
                  )}
                </div>
                {speaker.title && <div className="mb-2 text-[15px] font-semibold text-brand-500">{speaker.title}</div>}
                {speaker.role && <div className="text-[15px] leading-[1.55] text-grey-500">{speaker.role}</div>}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default WebinarSpeakers;
